import { useEffect, useRef } from "react";

export function useInterval(callback: () => void, intervalMs: number | undefined): void {
    
    const callbackRef = useRef<() => void>(undefined);
  
    // Remember the latest callback.
    useEffect(() => {

      callbackRef.current = callback;

    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
        let timerID: number | undefined;

        const doCallback = () => {
            if (callbackRef.current) {
            callbackRef?.current();
            }
        }

        // no need if no interval, this allows for the ability to pause/disable if needed
        if (intervalMs) {
            timerID = window.setInterval(doCallback, intervalMs);
        }

        // clean up
        return () => {

            if (timerID) {
                window.clearInterval(timerID);
            }
        }

    }, [intervalMs]);
  }